// extracted by mini-css-extract-plugin
export default {"invoicesWrapper":"HomePage_invoicesWrapper__5F2w1"};